import React from "react";
import "./Greeting.css";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import { greeting } from "../../portfolio";
import { Fade } from "react-reveal";
import ProfilePhoto from "../../assets/images/animated_ashutosh.png";
import { useLanguage } from "../../context/LanguageContext";
import { getTranslation } from "../../translations/translations";

export default function Greeting(props) {
  const theme = props.theme;
  const { language } = useLanguage();

  return (
    <Fade bottom duration={2000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1 className="greeting-text" style={{ color: "#FFFFFF" }}>
                {getTranslation(language, "greeting_title")}
              </h1>
              {greeting.nickname && (
                <h2 className="greeting-nickname" style={{ color: "#E0F5F0" }}>
                  ( {getTranslation(language, "a_spiritual_home")} )
                </h2>
              )}
              <p
                className="greeting-text-p subTitle"
                style={{ color: "#D0F0EA" }}
              >
                {getTranslation(language, "greeting_subtitle")}
              </p>
              <SocialMedia theme={theme} />
              <div className="portfolio-repo-btn-div">
                <Button
                  text={getTranslation(language, "donate")}
                  newTab={true}
                  href={greeting.portfolio_repository}
                  theme={theme}
                  className="portfolio-repo-btn"
                />
              </div>
            </div>
          </div>
          <div className="greeting-image-div">
            <img
              src={ProfilePhoto}
              alt="Profile photo"
              className="greeting-profile-photo"
            />
          </div>
        </div>
      </div>
    </Fade>
  );
}
